import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { requests } from "../../../common/RestAPI";
import { generateQueryParam, getTimestampToDate, sleep } from "../../../common/util";
import { SESSIONSTORAGE } from "../../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import { POPUP_TYPE } from "../../../value/type";


import { DetailProps } from "../../../interfaceTypes/ContentsProps";
import { useTranslation } from "react-i18next";
import { PurchaseData, detailTableHeaders, initPurchaseData } from "./PurchaseData";
import PurchaseDetail from "./PurchaseDetail";

export default function PurchaseDetailContainer(props: DetailProps) {
    const {t} = useTranslation();
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);

    const [targetId, setTargetId] = useState(props.targetId || '');

    const [refreshYn, setRefreshYn] = useState(false);
    const [loadPurchaseYn, setLoadPurchaseYn] = useState(false);
    
    const fetchIdRef = useRef(0);
    const [pageCount, setPageCount] = useState(0);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [detailData, setDetailData] = useState<PurchaseData>(initPurchaseData);
    
    const headers = useMemo(() => detailTableHeaders, []);

    const navigate = useNavigate();

    useEffect(() => {
        props.setLoading(false);
        AlertFunction('');
    }, []);

    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }

    useEffect(() => {
        if(!targetId) {
            const localTargetId = sessionStorage.getItem(SESSIONSTORAGE.SERVICE_PURCHASE_TARGET_ID);
            if(localTargetId) {
                setTargetId(localTargetId);
            } else {
                navigate(`${PAGE_URL.ERRORPAGE}`);
            }
        } else {
            sessionStorage.setItem(SESSIONSTORAGE.SERVICE_PURCHASE_TARGET_ID, targetId);
        }
    }, [props]);

    useEffect(() => {
        if(targetId) {
            executeLoadPurchase();
        }
    }, [targetId]);

    useEffect(() => {
        if(targetId && refreshYn) {
            executeLoadPurchase();
        }
    }, [refreshYn]);

    function executeLoadPurchase() {
        props.setLoading(true);
        requests.get(PLATFORM_URL.PURCHASE + "/" + targetId)
        .then((response) => {
            //set data
            if (response.status === 200 && response.data) {
                setDetailData(response.data);
            }
            setLoadPurchaseYn(true);
            props.setLoading(false);
            setRefreshYn(false);
        })
        .catch((error) => {
            //show error message
            setLoadPurchaseYn(true);
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            setRefreshYn(false);
            props.setLoading(false);
        });
    }

    return (
        targetId ?
        <PurchaseDetail
            detailData={detailData}
            infoText={infoText}
            infoError={infoError}
            headers={headers}
            refreshYn={refreshYn}
            loadMainDataYn={loadPurchaseYn}
        />
        : null
    )
    
}